// extracted by mini-css-extract-plugin
export default {"notfoundPage":"styles_notfoundPage__K2sZN","separador":"styles_separador__+SSPO"};